/**
 * Energy Monitor Card
 *
 * Displays real-time energy monitoring data for supported Kasa devices.
 */

import React from 'react';
import { KasaEnergyReading } from '../kasa-store';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Zap } from 'lucide-react';

interface EnergyMonitorCardProps {
  readings: KasaEnergyReading[];
}

export const EnergyMonitorCard: React.FC<EnergyMonitorCardProps> = ({ readings }) => {
  if (readings.length === 0) return null;

  const totalPowerW = readings.reduce((sum, r) => sum + r.power_mw / 1000, 0);

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm flex items-center gap-2">
          <Zap className="h-4 w-4 text-yellow-500" />
          Energy Overview
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div>
            <p className="text-xs text-muted-foreground">Total Power</p>
            <p className="text-lg font-semibold">{totalPowerW.toFixed(1)}W</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Active Monitors</p>
            <p className="text-lg font-semibold">{readings.length}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Avg Voltage</p>
            <p className="text-lg font-semibold">
              {readings.length > 0
                ? (readings.reduce((s, r) => s + r.voltage_mv, 0) / readings.length / 1000).toFixed(0)
                : 0}V
            </p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Total Energy</p>
            <p className="text-lg font-semibold">
              {(readings.reduce((s, r) => s + r.total_wh, 0) / 1000).toFixed(2)} kWh
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
